/** Valores admitidos en una interpolación `{placeholder}`. */
export type MessageParams = Record<string, string | number | null | undefined>;

/**
 * Interpola `{placeholder}` en un texto de `messages.ts`. Sin librería de i18n en esta fase: las claves
 * están en inglés, los valores en español y la forma queda lista para extraer.
 */
export function t(template: string, params?: MessageParams): string {
  if (!params) return template;
  return template.replace(/\{(\w+)\}/g, (match, key: string) => {
    const value = params[key];
    return value === undefined || value === null ? match : String(value);
  });
}
